import React from 'react';
import { RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';

import useTheme from '../SharedUtils/hooks';
import ResponsivePicture from './module/ResponsivePicture';
import ResponsiveVideo from './module/ResponsiveVideo';
import MastheadPlaceholder from './module/MastheadPlaceholder';
import Headline from '../SharedUtils/renderFields/headline';

import { getThemeProperties } from '../SharedUtils/utils';

import './styles/style.css';

const MastheadWithSubcomponent = (props) => {
  let widgetStyleList = {};
  const { isLight } = useTheme();
  const widgetClassList = ['o-widget', 'c-masthead-with-subcomponents'];
  const themeProperties = getThemeProperties(props.fields, isLight);
  const large =
    themeProperties.BackgroundImageLarge?.value?.src || 'https://placehold.co/1920x1080';
  const medium =
    themeProperties.BackgroundImageMedium?.value?.src || 'https://placehold.co/1024x768';
  const small = themeProperties.BackgroundImageSmall?.value?.src || 'https://placehold.co/600x400';
  const backgroundSrc = { large, medium, small };
  const hideBreadcrumbs = props.fields?.HideBreadcrumbs?.value == true ? 'hide-breadcrumbs' : '';
  const widgetOverlayClassList = ['c-masthead-with-subcomponents__overlay'];
  widgetOverlayClassList.push(
    'is-align-horizontal-' + (props.fields.ContentHorizontalAlignment?.displayName).toLowerCase() ||
      'left'
  );
  widgetOverlayClassList.push(
    'is-align-vertical-' +
      (props.fields.ContentVerticalAlignment?.displayName || '').toLowerCase() || 'center'
  );
  widgetClassList.push(isLight ? 'is-theme-light' : 'is-theme-dark');
  widgetOverlayClassList.push(hideBreadcrumbs);
  if (props.fields.ComponentHeight?.value !== '') {
    widgetStyleList['--masthead-height'] = props.fields.ComponentHeight?.value;
  }

  return (
    <div className={widgetClassList.join(' ')} style={widgetStyleList}>
      {props.fields.backgroundType === 'video' ? (
        <ResponsiveVideo videoSrc={backgroundSrc.large} videoSources={backgroundSrc} />
      ) : (
        <ResponsivePicture
          backgroundSrc={backgroundSrc.large}
          backgroundImages={backgroundSrc}
          alt="Masthead Background"
        />
      )}
      <div className={widgetOverlayClassList.join(' ')}>
        <Placeholder name="jss-masterhead-elements-breadcrumbs" rendering={props.rendering} />
        <div className="c-masthead-with-subcomponents__overlay__content">
          <Headline
            className="c-masthead-with-subcomponents__overlay__content-title"
            {...props}
          ></Headline>
          <RichText
            tabIndex="0"
            field={props.fields.Description}
            className="c-masthead-with-subcomponents__overlay__content-description"
          />
        </div>
        <MastheadPlaceholder placeholderName="masthead-subcomponent" rendering={props.rendering} />
      </div>
    </div>
  );
};

export default MastheadWithSubcomponent;
